// extracted by mini-css-extract-plugin
export default {"adminBox":"h3RhpJTluBAk2PJy0NFL","header":"rTEmdwdjzh5Qfs1fV2nA","content":"MMnw1G1W6BxHMvm9DTh3","variantDark":"MwFigxMrrh6qOPzdx3km"};